import { Toaster as Sonner } from "sonner";
import type { CSSProperties } from "react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Toasts that follow the theme tokens.
 *
 * sonner paints its own light or dark palette from its `theme` prop, and the
 * Toaster in routes/__root.tsx passes none, so toasts stay light on Dusk. The
 * Toaster is portalled to <body>, where the `dark` class on <html> still sets the
 * tokens, so reading the tokens here is enough for it to follow the theme without
 * knowing which one is on. `richColors` is on only because sonner applies the
 * --success-* and --error-* variables below under it. Those variables replace its
 * pastel fills and text colours with the popover surface and a status-coloured
 * border, so the colour comes from the tokens.
 *
 * To adopt: replace <Toaster …> in routes/__root.tsx with <AppToaster />.
 */
export function AppToaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{ style: { pointerEvents: "auto" } }}
      style={
        {
          "--normal-bg": "hsl(var(--popover))",
          "--normal-text": "hsl(var(--popover-foreground))",
          "--normal-border": "hsl(var(--popover-border))",
          "--success-bg": "hsl(var(--popover))",
          "--success-text": "hsl(var(--popover-foreground))",
          "--success-border": "hsl(var(--status-success))",
          "--error-bg": "hsl(var(--popover))",
          "--error-text": "hsl(var(--popover-foreground))",
          "--error-border": "hsl(var(--status-error))",
        } as CSSProperties
      }
      {...props}
    />
  );
}
